import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: ['DV_DP_CAST_CREW_HEADING'] as const,
}
